import { COMPONENTS } from '../../../components/components.registry';
import { ResultSlots } from '../../../components/pure/components.const';
import { ResultsConfig } from '../../../models';

export const DEFAULT_RESULTS_CONFIG: ResultsConfig = {
  all: {
    default: {
      template: {
        component: COMPONENTS.PURE.ResultTemplate,
        children: {
          link: {
            component: COMPONENTS.PURE.ResultLink,
            data: { class: 'ebx-result__link' },
            children: {
              image: {
                component: COMPONENTS.PURE.ResultImage,
                order: 0,
                data: { class: 'ebx-result__figure' },
                children: {
                  brokenImage: {
                    component: COMPONENTS.PURE.BrokenImageIcon,
                    data: { slot: ResultSlots.fallbackImage, class: ['ebx-result-figure__img--broken', 'ebx-result__img'] }
                  }
                }
              },
              title: {
                component: COMPONENTS.PURE.ResultTitle,
                order: 1,
                data: { class: 'ebx-result__title' }
              },
              price: {
                component: COMPONENTS.PURE.ResultPrice,
                order: 2,
                data: { class: 'ebx-result__price' }
              }
            }
          }
        }
      }
    }
  },
  resultsGrid: {},
  fallbackFilters: {},
  identifierSuggestions: {
    default: {
      template: {
        children: {
          link: {
            children: {
              identifier: {
                component: COMPONENTS.PURE.ResultIdentifier,
                order: 0,
                data: {
                  class: 'ebx-result__identifier'
                }
              },
              image: null,
              price: null
            }
          }
        }
      }
    }
  },
  nextQueries: {},
  partials: {},
  recommendations: {},
  resultsSuggestions: {},
  discoveryWall: {}
};
